<template>
  <div class="tags-wrapper">
    <StoryblokComponent
      v-for="childBlok in blok.tags"
      :key="childBlok._uid"
      :blok="childBlok"
    />
  </div>
</template>

<script setup lang="ts">
import type { SbTagsGroupStoryblok } from '@/types'
interface Props {
  blok: SbTagsGroupStoryblok
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.tags-wrapper {
  flex-wrap: wrap;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px 4px;

  @media (min-width: $breakpoint-lg) {
    gap: 16px;
  }
}
</style>
